import { ContactUsEmailSerializer } from "../../../recoil/types";
import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export const ContactUsRequest = async (
  contactUsInfo: ContactUsEmailSerializer,
  setLoggedOut: (inactivity: boolean) => void,
  access_token?: string,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/contact_us`,
    {
      body: JSON.stringify(contactUsInfo),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    },
    setLoggedOut,
  );
};

export default ContactUsRequest;
